import React, { FC, PropsWithChildren } from "react";
import { AuthProvider } from 'react-oidc-context';
import { WebStorageStateStore } from 'oidc-client-ts';


interface AuthenticationProviderProps {
}

// @ts-ignore
const env = window.env;
const iamUrl = env.IAM_URL?.endsWith('/realms')
    ? env.IAM_URL.slice(0, -7)
    : env.IAM_URL;

export const AuthenticationProvider: FC<AuthenticationProviderProps & PropsWithChildren> = (props) => {
    const search = window.location.search;
    const markerIdx = search.indexOf('&searchEnd');
    const cleanSearch = markerIdx !== -1
        ? search.substring(0, markerIdx)
        : search;
    const redirectUri = window.location.origin + window.location.pathname
        + cleanSearch + (cleanSearch.length > 0 ? '&searchEnd' : '');

    const onSigninCallback = (user: any | void): void => {
        sessionStorage.removeItem('oidc_recovery_attempted');
        const s = window.location.search;
        const idx = s.indexOf('searchEnd');
        const clean = idx !== -1
            ? s.substring(0, idx).replace(/[?&]$/, '')
            : '';
        window.history.replaceState(
            {},
            document.title,
            window.location.pathname + clean
        );
    };

    return (
        <AuthProvider
            authority={`${iamUrl}/realms/${env.IAM_REALM}`}
            client_id={env.IAM_CLIENT_ID}
            redirect_uri={redirectUri}
            post_logout_redirect_uri={window.location.origin}
            scope="openid profile email"
            automaticSilentRenew={true}
            accessTokenExpiringNotificationTimeInSeconds={10}
            userStore={new WebStorageStateStore({ store: window.sessionStorage })}
            onSigninCallback={onSigninCallback}
        >
            {props.children}
        </AuthProvider>
    );
};
